<template>
<div>
    <div class="mt-6 title primary--text d-flex align-center">
        <v-icon small color="accent" class="mr-2">fa-video</v-icon>
        <div>{{tit1}}</div>
    </div>
    <video ref="vid" width="100%" controls autoplay="autoplay" >
        <source :src="src1" type="video/mp4">
        Video not accepted by your browser.
    </video>

    <div class="mt-12 title primary--text d-flex align-center">
        <v-icon small color="accent" class="mr-2">fa-video</v-icon>
        <div>{{tit2}}</div>
    </div>
    <video ref="vid" width="100%" controls>
        <source :src="src2" type="video/mp4">
        Video not accepted by your browser.
    </video>
</div>
</template>

<script>
export default {
    props: ['src1', 'src2', 'tit1', 'tit2']
}
</script>